<template>
	<div id="quote-summary-template">
		<div v-if="!isAdmin"><isWaitingOverlay /></div>
		<appCreateProgressBar />
		
		<div class="container">
			<div class="col md-12 header">
				<h1>Your Survey Basket</h1>
			</div>

			<div class="col md-8 area-posts">
				<div class="area-post" v-for="(area, index) in savedAreas" :key="area.areaId">
					<div class="areas__count">{{index+1}}of{{savedAreas.length}}</div>
					<div class="col md-12 top">
						<div class="del-btn__wrap"><button class="del-btn" @click="deleteArea(area.areaId)"></button></div>
						<div class="col md-9">
							<div class="area-post__title">{{area.areaTitle | truncate(70)}}</div>
							<div class="area__subtitle">Total Area - <span> {{area.areaSquared.toLocaleString('en')}} sqm</span></div>
						</div>
						<div class="col md-3 area-post__preview">
							<button class="prev-btn" @click="openPreviewArea(area.areaId)">Preview Area</button>
						</div>
						<previewStaticMapModal :key="''+index" :areaTitle="area.areaTitle" :areaDesc="area.areaDescription" :areaId="area.areaId" :coordinates="area.kmlCoordinates"/>

					</div>
					<div class="col md-12">
						<table class="area-post__meta">
						<thead>
							<tr>
								<th>Land</th>
								<th>Building</th>
								<th>Drone</th>
								<th>Utilities</th>
								<th>File Upload</th>
								<th>Additional Details</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{{area.serviceOption1 === true ? 'Yes' : 'No'}}</td>
								<td>{{area.serviceOption2 === true ? 'Yes' : 'No'}}</td>
								<td>{{area.serviceOption3 === true ? 'Yes' : 'No'}}</td>
								<td>{{area.serviceOption4 === true ? 'Yes' : 'No'}}</td>
								<td>{{area.userUpload === true ? 'No' : 'Plan uploaded'}}</td>
								<td>{{area.additionalDetails[0] == "" ? 'None' : 'Yes'}}
								</td>
							</tr>
						</tbody>
					</table>
					</div>
				</div>
			</div>

			<div class="col md-4 quote-summary__user-meta">
				<div class="box account-info">
					<div class="box-panel box-header">
						Account Information
					</div>
					<div class="box-panel box-content" v-if="userInfo">
						<ul class="box__user-info">
							<li class="email">{{userInfo.email}}</li>
							<li class="primary-phone">{{userInfo.phoneNumber}}</li>
							<li class="secondary-phone" v-if="userInfo.phoneNumberTwo">{{userInfo.phoneNumberTwo}}</li>
							<div class="address">
								<li>{{userInfo.addressLineOne}}</li>
								<li>{{userInfo.addressLineTwo}}</li>
								<li>{{userInfo.postCode}}</li>
								<div class="clearfix"></div>
							</div>
						</ul>
					</div>
				</div>
				<div class="box survey-info">
					<div class="box-panel box-header">
						Survey Information
					</div>
					<div class="box-panel box-content">
						<ul class="box__survey-info">
							<li>Number of Areas <span>{{numberOfAreas}}</span></li>
							<li>Total Area <span>{{totalArea | currency('', 0)}}sqm</span></li>
						</ul>
					</div>
				</div>
				<div class="quote-summary__user-meta__cta">
					<button class="btn primary" @click="confirmSurveyModal">Confirm &amp; Request Quotation</button>
				</div>
			</div>
		</div>
		<ConfirmQuoteModal :totalArea="totalArea" :areaIdArray="areaIdArray"/>
		<div class="clearfix"></div>
	</div>
</template>

<script>

import CreateProgressBar from '../common/Create/CreateProgressBar';
import previewStaticMapModal from '../common/Modals/previewStaticMapModal';
import ConfirmQuoteModal from '../common/Modals/ConfirmQuoteModal';
import isWaitingMA from '@/components/common/isWaitingMA';



export default {
	data(){
		return {
			

		}
	},
	components : {
		appCreateProgressBar : CreateProgressBar,
		previewStaticMapModal : previewStaticMapModal,
		ConfirmQuoteModal : ConfirmQuoteModal,
		isWaitingOverlay : isWaitingMA

	},
	computed : {
		savedAreas(){
			return this.$store.getters.savedAreas;
		},
		userInfo(){
			return this.$store.getters.getUserInfo;
		},
		numberOfAreas(){
			return this.savedAreas.length;
		},
		totalArea(){
			let areas = this.savedAreas

			if(areas.length == 0){
				return;
			}

			let reducedObj = areas.reduce(function (a, b) {
				 return {areaSquared: a.areaSquared + b.areaSquared}; 
			})

			return reducedObj.areaSquared;
		},
		areaIdArray(){
			let areaIdArr = this.savedAreas.map((area) => {
				return area.areaId;
			})
			return areaIdArr;
		},
		isAdmin(){
			return this.userInfo.role === 'admin'
		}
	},

	created(){
	},
	
	methods : {
		deleteArea(areaId){
			return this.$store.dispatch('deleteArea', areaId)
			.then((response) => {
				console.log(response);
			})
			.catch((err) => {
				console.log(err);
			})
		},
		openPreviewArea(areaId){
			this.$store.commit('openModal', 'previewStaticMapModal' + areaId)
		},
		confirmSurveyModal(){
			this.$store.commit('openModal', 'ConfirmQuoteModal');
		}
	}, 

	
}
</script>



// WEBPACK FOOTER //
// src/components/pages/QuoteSummary.vue